import React from "react";
import { Link } from "react-router-dom";

export default function MedicalCenterCard({ center }) {
  const isInactive = center.status === "غیرفعال";

  return (
    <Link to={`/center/${center.id}`}>
      <div
        className="group flex flex-col overflow-hidden rounded-2xl p-4 
        bg-white rounded-2xl transition-all duration-500 
        shadow-[0_8px_30px_rgb(0,0,0,0.04)] 
        hover:shadow-[0_10px_30px_rgba(156,163,175,0.1)] 
        hover:-translate-y-1.5"
      >
        {/* Top Image Section */}
        <div className="relative overflow-hidden rounded-xl">
          <img
            src={center.img}
            alt={center.title}
            className={`h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
              isInactive ? "grayscale" : ""
            }`}
          />
          {/* Status Badge on Image */}
          {center.status && (
            <span
              className={`absolute left-3 top-3 rounded-lg px-2 py-[3px] text-[11px] font-medium tracking-wide
              text-white shadow-sm backdrop-blur-sm ${
                isInactive ? "bg-gray-800/80" : "bg-[#B00EB1]/80"
              }`}
            >
              {center.status}
            </span>
          )}
        </div>

        {/* Content Section */}
        <div className="flex flex-1 flex-col pt-5">
          <div className="flex flex-row items-center gap-1.5 lg:gap-2">
            {/* Profile Picture */}
            <div className="relative shrink-0">
              <img
                src={center.profile}
                alt={center.title}
                className="h-12 md:h-14 w-12 md:w-14 rounded-full border-2 border-gray-50 object-cover shadow-sm"
              />
            </div>

            {/* Text Content Wrapper */}
            <div className="min-w-0 flex-1">
              <div className="mb-1.5 flex w-full items-center justify-between gap-3">
                {/* Title */}
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-[14px] lg:text-[17px] font-bold text-gray-900 ">
                    {center.title}
                  </h3>
                </div>

                {/* Badges */}
                <div className="flex shrink-0 items-center justify-end gap-1.5">
                  {center.ownership && (
                    <span className="whitespace-nowrap rounded-full 
                    bg-gray-200/60 px-2 py-0.5 text-[10px] lg:text-[11px] font-medium text-gray-600 ">
                      {center.ownership}
                    </span>
                  )}

                  {typeof center.isOpen === "boolean" && (
                    <span
                      className={`whitespace-nowrap rounded-full
                         px-2 py-0.5 text-[10px] lg:text-[11px]  font-medium  ${
                        center.isOpen
                          ? "bg-emerald-100/60 text-emerald-600 "
                          : "bg-rose-100/60 text-rose-600 "
                      }`}
                    >
                      {center.isOpen ? "باز" : "بسته"}
                    </span>
                  )}
                </div>
              </div>

              {/* Category + Treatment Group */}
              <div className="flex flex-wrap items-center gap-2 
              text-[11px] text-gray-500 lg:text-[12px] md:pt-0.5">
                {center.category && (
                  <div className="flex min-w-0 items-center gap-1.5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 shrink-0 text-gray-400"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span className="line-clamp-1">{center.category}</span>
                  </div>
                )}

                {center.category && center.treatmentGroup && (
                  <span className="text-gray-300">•</span>
                )}

                {center.treatmentGroup && (
                  <div className="flex min-w-0 items-center gap-1.5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 shrink-0 text-gray-400"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                    <span className="line-clamp-1">
                      {center.treatmentGroup}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Spacer to push address to bottom if heights vary */}
          <div className="flex-1"></div>

          {/* Divider */}
          <hr className="mt-4 mb-3 border-gray-200" />

          {/* Address */}
          {center.city && center.address && (
            <div className="flex items-start gap-1 text-sm text-gray-500/65 lg:py-1 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mt-0.5 h-3.5
                w-3.5 shrink-0 text-gray-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span className="line-clamp-1 leading-relaxed text-[11px] md:text-[13px]">
                {center.city + "، " + center.address}{" "}
              </span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
